export default __webpack_public_path__ + "static/media/icon-template.7a09e1e8.svg";